import React, { useEffect, useState } from "react";
import "../../App.css"
import axios from "axios";
import { Spinner, Table, Card, Row, Col, Tabs, Tab, Button, ProgressBar } from "react-bootstrap";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

ChartJS.register(ArcElement, Tooltip, Legend);

const DashboardBpjs = () => {
    const [loading, setLoading] = useState(true);
    const [summary, setSummary] = useState(null);
    const [allUsers, setAllUsers] = useState([]);
    const [finishedUsers, setFinishedUsers] = useState([]);
    const [unfinishedUsers, setUnfinishedUsers] = useState([]);

    // state untuk "Show More"
    const [visibleAll, setVisibleAll] = useState(2);
    const [visibleFinished, setVisibleFinished] = useState(2);
    const [visibleUnfinished, setVisibleUnfinished] = useState(2);

    // state untuk tab aktif
    const [activeTab, setActiveTab] = useState("all");

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [res31, res32, res33, res34] = await Promise.all([
                    axios.get("https://onegml.com/cls/dashboard_functions/pooldata.php?sel=31"),
                    axios.get("https://onegml.com/cls/dashboard_functions/pooldata.php?sel=32"),
                    axios.get("https://onegml.com/cls/dashboard_functions/pooldata.php?sel=33"),
                    axios.get("https://onegml.com/cls/dashboard_functions/pooldata.php?sel=34"),
                ]);

                setSummary(res31.data);
                setAllUsers(Array.isArray(res32.data?.data) ? res32.data.data : []);
                setFinishedUsers(Array.isArray(res33.data?.data) ? res33.data.data : []);
                setUnfinishedUsers(Array.isArray(res34.data?.data) ? res34.data.data : []);
            } catch (error) {
                console.error("Error fetching surveys:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const renderTable = (users, visible, setVisible) => (
        <>
            <Table striped bordered hover responsive size="sm">
                <thead>
                    <tr>
                        <th>No</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {users.slice(0, visible).map((user, idx) => (
                        <tr key={idx}>
                            <td>{idx + 1}</td>
                            <td>{user.real_name}</td>
                            <td>{user.email}</td>
                            <td>{user.status}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            {visible < users.length && (
                <div className="text-center mb-3">
                    <Button variant="primary" size="sm" onClick={() => setVisible(visible + 2)}>
                        Show More
                    </Button>
                </div>
            )}
        </>
    );

    // Pie Chart Data
    const pieData = {
        labels: ["Complete", "Incomplete"],
        datasets: [
            {
                data: [summary?.finished_user || 0, summary?.unfinished_user || 0],
                backgroundColor: ["#4caf50", "#f44336"],
                hoverBackgroundColor: ["#66bb6a", "#e57373"],
            },
        ],
    };

    // fungsi export excel
    const exportToCSV = (apiData, fileName) => {
        const ws = XLSX.utils.json_to_sheet(apiData);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
        });
        FileSaver.saveAs(data, fileName + ".xlsx");
    };

    // pilih data sesuai tab aktif
    const handleExport = () => {
        if (activeTab === "all") {
            exportToCSV(allUsers, "All_Users");
        } else if (activeTab === "finished") {
            exportToCSV(finishedUsers, "Completed_Users");
        } else if (activeTab === "unfinished") {
            exportToCSV(unfinishedUsers, "Incompleted_Users");
        }
    };

    return (
        <>
            {loading ? (
                <div className="text-center p-5">
                    <Spinner animation="border" />
                </div>
            ) : (
                <div className="p-4 bpjs-survey">
                    <h4 className="mb-4 d-flex justify-content-between align-items-center">
                        BPJS Surveys
                        <Button variant="success" size="sm" onClick={handleExport}>
                            Export to Excel
                        </Button>
                    </h4>

                    <Row className="mb-4">
                        <Col md={4} className="d-flex flex-column gap-3">
                            <Card className="shadow-sm flex-fill">
                                <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                                    <h6>Total Responden</h6>
                                    <h4>{summary?.total_user}</h4>
                                </Card.Body>
                            </Card>
                            <Card className="shadow-sm flex-fill">
                                <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                                    <h6>Total Selesai</h6>
                                    <h4>{summary?.finished_user}</h4>
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col md={4} className="d-flex flex-column gap-3">
                            <Card className="shadow-sm flex-fill">
                                <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                                    <h6>Completion %</h6>
                                    <h4>{summary?.percentage_finished}%</h4>
                                    <ProgressBar now={summary?.percentage_finished || 0} style={{ width: "100%" }} />
                                </Card.Body>
                            </Card>
                            <Card className="shadow-sm flex-fill">
                                <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                                    <h6>Total Belum Selesai</h6>
                                    <h4>{summary?.unfinished_user}</h4>
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col md={4} className="d-flex flex-column gap-3">
                            <Card className="shadow-sm flex-fill">
                                <Card.Body className="d-flex flex-column justify-content-center align-items-center">
                                    <h6>Data Chart</h6>
                                    <Pie data={pieData} />
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    {/* Tabs for Users */}
                    <Tabs
                        activeKey={activeTab}
                        onSelect={(k) => setActiveTab(k || "all")}
                        id="bpjs-tabs"
                        className="mb-3"
                        style={{
                            backgroundColor: "#e3e3e3ff",
                            borderRadius: "8px",
                            padding: "5px",
                            fontWeight: "500",
                        }}
                        variant="pills"
                        mountOnEnter
                        unmountOnExit
                    >
                        <Tab
                            eventKey="all"
                            title={<span style={{ color: "#007bff", fontSize: "14px" }}>All Users</span>}
                        >
                            {renderTable(allUsers, visibleAll, setVisibleAll)}
                        </Tab>
                        <Tab
                            eventKey="finished"
                            title={<span style={{ color: "#28a745", fontSize: "14px" }}>Completed Users</span>}
                        >
                            {renderTable(finishedUsers, visibleFinished, setVisibleFinished)}
                        </Tab>
                        <Tab
                            eventKey="unfinished"
                            title={<span style={{ color: "#dc3545", fontSize: "14px" }}>Incompleted Users</span>}
                        >
                            {renderTable(unfinishedUsers, visibleUnfinished, setVisibleUnfinished)}
                        </Tab>
                    </Tabs>
                </div>
            )}
        </>
    );
};

export default DashboardBpjs;
